// extracted by mini-css-extract-plugin
module.exports = {"icon":"_7a3fb80146--icon--u7322","logo":"_7a3fb80146--logo--lZMfA"};